import { tryLoadLightDOMStyles } from '@/components/webcomponents/Global/loadDependency'
import { getTemplateNavFooterLevel0LinkStyles } from './NavFooterLevel0Link.styles'

const t = document.createElement('template')
t.innerHTML = `
<span class="ascend-footer__item" role="listitem">
  <slot></slot>
</span>
`
const TemplateNavFooterLevel0Link = t

class NavFooterLevel0Link extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavFooterLevel0LinkStyles().content.cloneNode(true))
    shadow.appendChild(TemplateNavFooterLevel0Link.content.cloneNode(true))

    tryLoadLightDOMStyles('NavFooterLevel0Link.css')
  }

  connectedCallback() {
    console.log('NavFooterLevel0Link connectedCallback')
  }
}

if (!customElements.get('ts-navfooter-level0-link')) {
  customElements.define('ts-navfooter-level0-link', NavFooterLevel0Link)
}
export { NavFooterLevel0Link }
